import { handleActions } from 'redux-actions';

import * as types from './types';
import { sortObjectsByNameAsc } from '../../helpers/utils';

import { DimensionsResponse, DimensionsStore } from '../../types/redux/stores/dimensions.types';
import { SimpleAction } from '../../types/redux/actions';

const initialState: DimensionsStore = {
  data: [],
  error: null,
  initialLoad: false,
  loading: false,
  saving: false,
};

const getDimensionsRequest = (state: DimensionsStore): DimensionsStore => {
  return {
    ...state,
    error: null,
    loading: true,
  };
};
const getDimensionsRequestFailure = (state: DimensionsStore, action: SimpleAction): DimensionsStore => {
  return {
    ...state,
    error: action.error,
    loading: false,
  };
};
const getDimensionsRequestSuccess = (state: DimensionsStore, action: SimpleAction<DimensionsResponse>): DimensionsStore => {
  const data = (action?.payload?.res || []).map((d) => {
    d.values.sort(sortObjectsByNameAsc);
    return d;
  });

  return {
    ...state,
    data,
    error: null,
    initialLoad: true,
    loading: false,
  };
};

export default handleActions(
  {
    [types.GET_DIMENSIONS_REQUEST]: getDimensionsRequest,
    [types.GET_DIMENSIONS_REQUEST_FAILURE]: getDimensionsRequestFailure,
    [types.GET_DIMENSIONS_REQUEST_SUCCESS]: getDimensionsRequestSuccess,
  },
  initialState
);
